import { configureStore } from '@reduxjs/toolkit';
import uiReducer, { persistTheme } from './uiSlice';
import designerReducer from './designerSlice';

export const store = configureStore({
  reducer: {
    ui: uiReducer,
    designer: designerReducer,
  },
  middleware: (getDefault) =>
    // The designer holds whole Flow IR definitions (plain JSON, but large-ish); the default
    // serializability/immutability checks would walk them on every edit. They ARE serialisable —
    // we disable the dev-only deep scans to keep editing snappy at the performance budget (spec §15).
    getDefault({ serializableCheck: false, immutableCheck: false }),
});

// Persist theme choice across sessions (long-shift operators keep their setting).
let lastTheme = store.getState().ui.theme;
store.subscribe(() => {
  const t = store.getState().ui.theme;
  if (t !== lastTheme) {
    lastTheme = t;
    persistTheme(t);
  }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
